(() => {
  if (window.__categorySidebarBound) return;
  window.__categorySidebarBound = true;

  const desktopQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1025px)');
  let lastFocus = null;
  let hoverTimer = 0;
  let closeTimer = 0;

  const root = () => document.querySelector('[data-cats-root]');
  const trigger = () => document.querySelector('[data-cats-open]');
  const canHover = () => desktopQuery.matches;
  const items = () => document.querySelectorAll('[data-cats-item]');

  const setHeaderOffset = () => {
    const menu = root();
    if (!menu) return;
    menu.style.setProperty('--cats-top', '0px');
  };

  const setExpanded = (key) => {
    items().forEach((item) => {
      const active = key !== '' && item.dataset.catsItem === key;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-expanded', item.dataset.hasChildren === 'true' ? (active ? 'true' : 'false') : 'false');
    });
    const button = trigger();
    if (button) button.setAttribute('aria-expanded', root()?.classList.contains('is-open') ? 'true' : 'false');
  };

  const showPanel = (key) => {
    const menu = root();
    if (!menu || !key) return;
    const panel = menu.querySelector(`[data-category-mega-panel="${CSS.escape(key)}"]`);
    menu.querySelectorAll('[data-category-mega-panel]').forEach((item) => {
      item.hidden = item !== panel;
    });
    const live = menu.querySelector('[data-cats-livehead]');
    const row = document.querySelector(`[data-cats-item="${CSS.escape(key)}"]`);
    if (live && row) {
      const label = row.querySelector('.cats-item__label');
      const link = row.querySelector('a.cats-item__link');
      const parent = live.querySelector('[data-cats-liveparent]');
      live.hidden = !panel;
      if (parent && label) {
        parent.textContent = label.textContent.trim();
        if (link && link.getAttribute('href')) parent.setAttribute('href', link.getAttribute('href'));
        else parent.removeAttribute('href');
      }
    }
    setExpanded(panel ? key : '');
  };

  const firstKey = () => {
    const first = document.querySelector('[data-cats-item][data-has-children="true"]');
    return first ? first.dataset.catsItem : '';
  };

  const open = (key) => {
    const menu = root();
    const button = trigger();
    if (!menu) return;
    window.clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    setHeaderOffset();
    menu.hidden = false;
    menu.inert = false;
    menu.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cats-open');
    requestAnimationFrame(() => {
      menu.classList.add('is-open');
      showPanel(key || firstKey());
    });
    if (button) button.setAttribute('aria-expanded', 'true');
  };

  const close = () => {
    const menu = root();
    const button = trigger();
    if (!menu) return;
    window.clearTimeout(hoverTimer);
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cats-open');
    setExpanded('');
    if (button) button.setAttribute('aria-expanded', 'false');
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      if (menu.classList.contains('is-open')) return;
      menu.inert = true;
      menu.hidden = true;
      menu.querySelectorAll('[data-category-mega-panel]').forEach((item) => {
        item.hidden = true;
      });
    }, 240);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  const toggle = () => {
    const menu = root();
    if (!menu) return;
    if (menu.classList.contains('is-open')) close();
    else open();
  };

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-cats-open]');
    if (openBtn) {
      event.preventDefault();
      toggle();
      return;
    }

    if (event.target.closest('[data-cats-close]')) {
      close();
      return;
    }

    const item = event.target.closest('[data-cats-item]');
    if (item && item.dataset.hasChildren === 'true' && event.target.closest('[data-cats-arrow]')) {
      event.preventDefault();
      if (root()?.classList.contains('is-open')) showPanel(item.dataset.catsItem);
    }
  });

  document.addEventListener('mouseover', (event) => {
    if (!canHover()) return;
    const menu = root();
    if (!menu || !menu.classList.contains('is-open')) return;
    const item = event.target.closest('[data-cats-item]');
    if (!item || item.dataset.hasChildren !== 'true') return;
    window.clearTimeout(hoverTimer);
    hoverTimer = window.setTimeout(() => {
      if (root()?.classList.contains('is-open')) showPanel(item.dataset.catsItem);
    }, 70);
  });

  document.addEventListener('keydown', (event) => {
    const menu = root();
    if (!menu || !menu.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key === 'ArrowRight') {
      const current = event.target.closest('[data-cats-item]');
      if (current) {
        event.preventDefault();
        showPanel(current.dataset.catsItem);
        const firstLink = menu.querySelector('[data-category-mega-panel]:not([hidden]) a:not([aria-disabled="true"])');
        if (firstLink) firstLink.focus();
      }
    }

    if (event.key === 'ArrowLeft' && event.target.closest('[data-category-mega-panel]')) {
      event.preventDefault();
      const active = menu.querySelector('[data-cats-item].is-active a');
      if (active) active.focus();
    }
  });

  window.addEventListener('resize', () => {
    if (root()?.classList.contains('is-open')) setHeaderOffset();
  });

  desktopQuery.addEventListener('change', () => {
    if (!canHover() && root()?.classList.contains('is-open')) {
      const active = document.querySelector('[data-cats-item].is-active');
      if (active) showPanel(active.dataset.catsItem);
    }
  });

  document.addEventListener('shopify:section:load', close);
  document.addEventListener('shopify:section:unload', close);
})();
